import moment from 'moment-timezone';

// Remembers for a year that this browser finished the survey, both on our domain and,
// via postMessage, on the host page when Ellie runs embedded in an iframe.
export const markSurveyDone = (cookies, surveyName) => {
  if (surveyName === 'info') return;
  const name = 'elli_' + surveyName;
  if (cookies.get(name)) return;
  const expires = moment()
    .add(1, 'year')
    .toDate();

  document.cookie = name + '=1;expires=' + expires + '; SameSite=None; Secure';
  window.parent.postMessage(
    { func: 'setC', message: name + '=1;path=/;expires=' + expires + '; ' },
    '*'
  );
  cookies.set(name, 1, { domain: 'chatwithelli.com', expires });
};
